import React, { useState } from 'react';
import styled from 'styled-components';
import { Container, CompletionCard, CenteredContainer, T1, Description, ButtonContainer, TopBanner } from '../../styles/SurveyStyles';

const Logo = styled.img`
  height: 30px;
  position: absolute;
  top: 20px;
  left: 20px;
`;

const ActionButton = styled.button`
  background-color: ${props => props.themeColors?.buttonColor || '#007bff'};
  color: white;
  border: none;
  border-radius: 8px;
  padding: 12px 24px;
  margin: 12px;
  cursor: pointer;
  font-weight: 600;
  transition: all 0.2s ease;
  
  &:hover {
    opacity: 0.9;
    transform: translateY(-2px);
  }
  
  &:active {
    transform: translateY(0);
  }
  
  &:disabled {
    opacity: 0.7;
    cursor: not-allowed;
    transform: none;
  }
`;

const EnhancedCompletionCard = styled(CompletionCard)`
  border: none;
  border-radius: 16px;
  padding: 32px;
  background: white;
  transition: opacity 0.3s ease-out;
  opacity: ${props => props.isTransitioning ? '0' : '1'};
`;

const SurveyPartialData = ({ themeColors, onContinue, onRestart, logo }) => {
  const [isTransitioning, setIsTransitioning] = useState(false);
  const [buttonsDisabled, setButtonsDisabled] = useState(false);
  
  const handleContinue = (e) => {
    e.preventDefault();
    setButtonsDisabled(true);
    setIsTransitioning(true);
    
    // Delay the actual transition to allow for fade-out animation
    setTimeout(() => {
      onContinue();
    }, 300);
  };
  
  const handleRestart = (e) => {
    e.preventDefault();
    setButtonsDisabled(true);
    setIsTransitioning(true);
    
    // Delay the actual transition to allow for fade-out animation
    setTimeout(() => {
      onRestart();
    }, 300);
  };

  return (
    <Container themeColors={themeColors}>
      <TopBanner themeColors={themeColors}>
        <Logo src={logo} alt="Logo" />
      </TopBanner>
      <EnhancedCompletionCard isTransitioning={isTransitioning}>
        <CenteredContainer>
          <T1>Resume Your Survey</T1>
          <Description>
            We found that you previously started this survey but didn't complete it.
            Would you like to continue where you left off or start fresh?
          </Description>
          <ButtonContainer>
            <ActionButton 
              onClick={handleContinue} 
              themeColors={themeColors}
              disabled={buttonsDisabled}>
              Continue from last position
            </ActionButton>
            <ActionButton 
              onClick={handleRestart} 
              themeColors={themeColors}
              disabled={buttonsDisabled}
              style={{ 
                backgroundColor: 'transparent', 
                color: themeColors.buttonColor || '#007bff',
                border: `2px solid ${themeColors.buttonColor || '#007bff'}`
              }}>
              Start from beginning
            </ActionButton>
          </ButtonContainer>
        </CenteredContainer>
      </EnhancedCompletionCard>
    </Container>
  );
};

export default SurveyPartialData; 